/**
 * Possui todas as variáveis de ambiente que são utilizadas na aplicação.
 *
 * Já realiza uma tratativa adequada do tipo da variável, antes de retorna-la.
 */
export class Env {
  // OBS: O tipo das variáveis é forçado no retorno, pois é esperado que a tenha sido informada corretamente.

  // TODO: Ambos os todos abaixo são mais para a frente, pois não consegui ver isso corretamente no Next.js. (ass: Nicolas)
  // TODO: Criar uma validação para as variáveis antes de executar a aplicação.
  // TODO: Logar as variáveis antes de executar a aplicação.

  static get NODE_ENV() {
    return process.env.NODE_ENV as 'production' | 'development' | 'staging';
  }

  static get LOG_KNOWN_ERRORS() {
    return process.env.LOG_KNOWN_ERRORS === '1';
  }

  static get NEXT_PUBLIC_URL() {
    return process.env.NEXT_PUBLIC_URL;
  }

  static get PAYMENT_SERVICE_API_URL() {
    return process.env.PAYMENT_SERVICE_API_URL;
  }

  static get MONGODB_URL() {
    return process.env.MONGODB_URL || '';
  }

  static get CRYPTO_KEY_CREDIT_CARD() {
    return process.env.CRYPTO_KEY_CREDIT_CARD || '';
  }

  static get CRYPTO_KEY_CPF_CNPJ() {
    return process.env.CRYPTO_KEY_CPF_CNPJ || '';
  }

  static get CRYPTO_KEY_ERP() {
    return process.env.CRYPTO_KEY_ERP || '';
  }

  static get CRYPTO_KEY_TENANT() {
    return process.env.CRYPTO_KEY_TENANT || '';
  }

  static get S3_BUCKET_NAME() {
    return process.env.S3_BUCKET_NAME || '';
  }

  static get S3_REGION() {
    return process.env.S3_REGION || '';
  }

  static get S3_ENDPOINT_URL() {
    return process.env.S3_ENDPOINT_URL || '';
  }

  static get S3_ACCESS_KEY() {
    return process.env.S3_ACCESS_KEY || '';
  }

  static get S3_SECRET_KEY() {
    return process.env.S3_SECRET_KEY || '';
  }

  static get BUCKET_URL() {
    return process.env.BUCKET_URL || '';
  }

  static get ADMIN_AUTHZ_TOKEN() {
    return process.env.ADMIN_AUTHZ_TOKEN || '';
  }

  static get ADMIN_AUTH_JWE_PUBLIC_KEY() {
    return process.env.ADMIN_AUTH_JWE_PUBLIC_KEY || '';
  }
  static get ADMIN_AUTH_JWE_PRIVATE_KEY() {
    return process.env.ADMIN_AUTH_JWE_PRIVATE_KEY || '';
  }

  static get RESELLER_AUTH_JWE_PUBLIC_KEY() {
    return process.env.RESELLER_AUTH_JWE_PUBLIC_KEY || '';
  }
  static get RESELLER_AUTH_JWE_PRIVATE_KEY() {
    return process.env.RESELLER_AUTH_JWE_PRIVATE_KEY || '';
  }

  static get RESELLER_API_JWE_PUBLIC_KEY() {
    return process.env.RESELLER_API_JWE_PUBLIC_KEY || '';
  }
  static get RESELLER_API_JWE_PRIVATE_KEY() {
    return process.env.RESELLER_API_JWE_PRIVATE_KEY || '';
  }

  static get CUSTOMER_AUTH_JWE_PUBLIC_KEY() {
    return process.env.CUSTOMER_AUTH_JWE_PUBLIC_KEY || '';
  }
  static get CUSTOMER_AUTH_JWE_PRIVATE_KEY() {
    return process.env.CUSTOMER_AUTH_JWE_PRIVATE_KEY || '';
  }

  static get PUBLIC_AREA_AUTH_JWE_PUBLIC_KEY() {
    return process.env.PUBLIC_AREA_AUTH_JWE_PUBLIC_KEY || '';
  }
  static get PUBLIC_AREA_AUTH_JWE_PRIVATE_KEY() {
    return process.env.PUBLIC_AREA_AUTH_JWE_PRIVATE_KEY || '';
  }
}
